import { render, staticRenderFns } from "./StartArrivalNodeStats.vue?vue&type=template&id=d96ebbb4&scoped=true&"
import script from "./StartArrivalNodeStats.vue?vue&type=script&lang=js&"
export * from "./StartArrivalNodeStats.vue?vue&type=script&lang=js&"
import style0 from "./StartArrivalNodeStats.vue?vue&type=style&index=0&id=d96ebbb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ebbb4",
  null
  
)

export default component.exports